Wee.fn.make('grid', {
	_construct: function(options) {
		var $priv = this.$private;

		// Set defaults for grid and extend with options
		$priv.conf = Wee.$extend({
			name: 'grid',
			breakpoints: [
				{
					min: 1,
					columns: 3
				}
			],
			$grid: $('ref:grid')
		}, options);

		// Get all items in the grid
		$priv.conf.$gridItems = $('ref:gridItem', $priv.conf.$grid);

		$priv.mapScreen($priv.conf.breakpoints);
	},

	/**
	 * Reset all events bound to grid
	 */
	destroy: function() {
		Wee.screen.reset(this.$private.conf.name);
	}
}, {
	/**
	 * Init build columns and grid
	 *
	 * @private
	 */
	init: function() {
		// Create columns in specified grid according to given number of columns
		this.buildColumns(this.conf.$grid, this.conf.columns);

		// Build layout of columns
		this.buildLayout(this.conf.$gridItems, this.conf.$grid, this.conf.columns);

		// Remove -is-diabled class from grid
		this.conf.$grid.enable();
	},

	/**
	 * Update number of columns in grid
	 *
	 * @private
	 */
	update: function() {
		$('ref:column', this.conf.$grid).remove();
		this.buildColumns(this.conf.$grid, this.conf.columns);
		this.buildLayout(this.conf.$gridItems, this.conf.$grid, this.conf.columns);
	},

	/**
	 * [mapScreen description]
	 * @param  breakpoints $priv.conf.breakpoints
	 * @private
	 */
	mapScreen: function(breakpoints) {
		var scope = this,
			initOptions = [],
			options = [];

		if (breakpoints) {
			breakpoints.forEach(function(breakpoint) {
				// Get columns on each breakpoint
				var columns = breakpoint.columns,
					init = {
						// Disabled callback after first execution
						once: true,
						// Do not immediately evaluate breakpoint logic
						init: false,
						namespace: 'gridOnce',
						callback: function() {
							// Set number of columns for this breakpoint
							scope.conf.columns = columns;
							// Run init() method to build columns and layout
							scope.init();
							// Reset events bound to gridOnce namespace
							Wee.screen.reset('gridOnce');
						}
					},
					afterInit = {
						init: false,
						namespace: scope.conf.name,
						callback: function() {
							scope.conf.columns = columns;
							scope.update();
						}
					};

				// Clean breakpoint object before extending
				delete breakpoint.columns;

				// Extend init object w/ breakpoint object for each breakpoint
				// And add into initOptions array
				initOptions.push(Wee.$extend(init, breakpoint));

				// Extend afterInit object w/ breakpoint object for each breakpoint
				// And add into options array
				options.push(Wee.$extend(afterInit, breakpoint));
			});

			// Evaluate initial state and destroy mapping
			// We cannot use 'init' on 'gridOnce' mappings since
			// we need all maps registered before evaluating 'gridOnce' mappings
			Wee.screen.map(initOptions);
			Wee.screen.run('gridOnce');

			// Map breakpoints for updating columns
			Wee.screen.map(options);
		}
	},

	/**
	 * Build columns from grid items
	 * @param  $grid       $priv.conf.grid
	 * @param  columnCount $priv.conf.columns
	 * @private
	 */
	buildColumns: function($grid, columnCount) {
		var columns = [];

		for (var i = 0; i < columnCount; i++) {
			columns.push('<div class="grid__column -columns-' + columnCount + '" data-ref="column"></div>');
		}

		$grid.append(columns.join(''));
		Wee.$setRef($grid);
	},

	/**
	 * Build layout of columns
	 * @param  $gridItems  $priv.conf.gridItems
	 * @param  $grid       $priv.conf.grid
	 * @param  columnCount $priv.conf.columns
	 * @private
	 */
	buildLayout: function($gridItems, $grid, columnCount) {
		var $columns = $('ref:column', $grid),
			currentColumn = 0;

		$gridItems.each(function(el) {
			$columns.eq(currentColumn).append(el);

			currentColumn = currentColumn >= columnCount - 1 ? 0 : currentColumn + 1;
		});

		Wee.$setRef();
	}
}, {
	instance: false
});